import React, {useEffect, useState} from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form'; 
import { useTranslation, Trans } from 'react-i18next';

import { CommentContainer } from './Evaluation/CommentContainer';
import { IconChip } from '../components/IconChip';
import { HeaderSurvey } from '../components/HeaderSurvey';
import { StepperSurvey } from '../components/StepperSurvey';
import { listCriteria } from '../data/criteria';
import { CriteriaCard } from '../components/Criteria/CriteriaCard';
import { closeSurvey, resetSurvey, setStepSurvey, setSurveyId } from '../slices/surveySlice';
import { createSurvey, updateSurvey } from '../api/surveyApi';
import { startResetSelected } from '../slices/mapSlice';
import { openSummary } from '../slices/summarySlice';
import { setRefetch } from '../slices/initSlice';

const usageMap = {
  'none': 'none',
  'go_to_work': 'work',
  'go_to_school': 'school',
  'go_to_market': 'market',
  'take_a_walk': 'walk',
  'other': 'other'
};

export const FormSurvey = ({stepEvaluation, steps, surveyResults}) => {
  const dispatch = useDispatch();
  const {
    register, 
    watch , 
    handleSubmit, 
    setValue, 
    control,
  } = useForm({defaultValues: surveyResults});
  const {t} = useTranslation();

  const criteriaShow = useSelector(state => state.init.attributs);

  const userId = useSelector(state => state.user.uuid);
  const userEmail = useSelector(state => state.user.email);

  const typeSurvey = useSelector(state => state.survey.type);
  const surveyId = useSelector(state => state.survey.surveyId);
  const labelSelected = useSelector(state => state.poi.labelPoi);

  const [listCriteriaShown, setListCriteriaShown] = useState(listCriteria);

  const renderHeader = () => {
    switch (stepEvaluation) {
      case 'practicability':
        return `${t('survey.practicability_title')}`;
      case 'comfort':
        return `${t('survey.comfort_title')}`;
      case 'security':
        return `${t('survey.security_title')}`;
      case 'comment':
        return `${t('survey.comment_title')}`;
      default:
        return `${t('survey.default_title')}`;
    }
  };

  const handleCriteriaPos = (id) => {
    setValue(id, true);
  };

  const handleCriteriaNev = (id) => {
    setValue(id, false);
  };

  const handleRemoveCriteria = (id) => {
    setValue(id, null);
  };

  const handleFinishSurvey = () => {
    dispatch(closeSurvey());
    dispatch(setRefetch(true));
    dispatch(startResetSelected());
    dispatch(resetSurvey());
  };


  const handleMoveToSummary = () => {
    handleFinishSurvey();
    dispatch(openSummary());
  };

  const handleMoveToUserInfo = () => {
    dispatch(setStepSurvey('userInfo'));
  };

  const handleCreateSurvey = (data) => {
    if(userId !== null) {
      createSurvey({...data, owner_uuid: userId}).then((results) => {
        dispatch(setSurveyId(results.id));
        dispatch(setRefetch(true));
        if (userEmail === null) {
          handleMoveToUserInfo();
        } else {
          handleMoveToSummary();
        }
      });
    } else {
      createSurvey(data).then((results) => {
        dispatch(setSurveyId(results.id));
        dispatch(setRefetch(true));
        handleMoveToUserInfo();
      });
    }
  };

  const handleUpdateSurvey = (data) => {
    if (userId !== null && surveyId !== null) {
      updateSurvey(userId, surveyId, data).then((results) => {
        dispatch(setSurveyId(results.id));
        dispatch(setRefetch(true));
        if (userEmail === null) {
          dispatch(setStepSurvey('userInfo'));
        } else {
          handleMoveToSummary();
        }
      });
    }
  };

  const onSubmit = (data) => {
    const dataToSubmit = {
      ...data,
      street_usages: data.street_usages.length > 0 ? data.street_usages.map(elem => usageMap[elem]) : null
    };
    if (typeSurvey === 'update') {
      handleUpdateSurvey(dataToSubmit);
    } else {
      handleCreateSurvey(dataToSubmit);
    }
  };

  useEffect(() => {
    const listResults = listCriteria.map(elem => {
      return {...elem, show: criteriaShow[elem.id]};
    });
    setListCriteriaShown(listResults);
  }, []);

  return (
    <div className='survey-body min-h-60 flow'>
      <IconChip step={stepEvaluation}/>
      <HeaderSurvey label={renderHeader(labelSelected)}/>
      <form id='survey-form' onSubmit={handleSubmit(onSubmit)}>
        {stepEvaluation !== 'comment' ? (
          <>
            <p>
              <Trans i18nKey='survey.explain_selection' components={{u : <u/>, b: <b/>}} />
            </p>
            <StepperSurvey 
              steps={steps} 
              currentStep={stepEvaluation}
              
            />
            <ul className='list-select grid grid-col-1 md:grid-col-2 md:gap-2 has-buttons'>
              {listCriteriaShown.filter(elem => elem.theme === stepEvaluation).map(elem => {
                if (elem.show) {
                  return (
                    <li key={elem.id}>
                      <CriteriaCard 
                        id={elem.id}
                        label={t(`criteria.${elem.id}_label`)} 
                        details={t(`criteria.${elem.id}_details`)} 
                        handlePos={() => handleCriteriaPos(elem.id)}
                        handleNev={() => handleCriteriaNev(elem.id)}
                        handleReset={() => handleRemoveCriteria(elem.id)}
                        value={watch(elem.id)} 
                      />
                    </li>
                  );
                }
              })}
            </ul>
          </>
        ): (
          <CommentContainer 
            register={register}
            control={control}
            watch={watch}
            setValue={setValue}
          />
        ) }
      </form>
    </div>
  );
};